// App-wide event bus: core emits, UI subscribes. Keeps core DOM-free.

import { Emitter } from "../lib/events";
import type { DecisionNode } from "./state";

export interface RenderNodeOpts { thinking?: boolean; keepQuestion?: boolean }

export type AppEvents = {
  "render:all": Record<string, never>;
  "render:node": { node: DecisionNode; opts?: RenderNodeOpts };
  "render:grounding": Record<string, never>;
  "render:constraints": Record<string, never>;
  "prefetch:ready": { index: number };
  "option:highlight": { index: number };
  "toast": { msg: string };
  "decision": { nodeId: string };
};

export const bus = new Emitter<AppEvents>();

export const toast = (msg: string) => bus.emit("toast", { msg });
export const renderAll = () => bus.emit("render:all", {});
